"use client"

import { cn } from "@/lib/utils"

export type MediaDeletedUndoSnackbarProps = {
  open: boolean
  onUndo: () => void
  message?: string
}

/**
 * Bottom snackbar for deferred media delete: matches archive “notice” styling;
 * mobile centered, desktop bottom-right.
 */
export function MediaDeletedUndoSnackbar({
  open,
  onUndo,
  message = "Photo removed",
}: MediaDeletedUndoSnackbarProps) {
  if (!open) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "surface-overlay z-toast pointer-events-none fixed max-w-[min(92vw,22rem)] motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2 motion-safe:duration-200",
        "bottom-[max(1.25rem,env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 px-3 py-2.5",
        "sm:bottom-8 sm:left-auto sm:right-6 sm:translate-x-0 sm:px-4",
      )}
    >
      <div className="pointer-events-auto flex items-center justify-between gap-4">
        <span className="type-caption text-foreground">{message}</span>
        <button
          type="button"
          onClick={onUndo}
          className="type-caption shrink-0 font-medium text-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
        >
          Undo
        </button>
      </div>
    </div>
  )
}
